import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import FormEditor from "@/components/FormEngine/Editor";
import { SchemaBuilderFormModal } from "@/modules/schema-builder/schema-builder-form-modal";

/*
 * Component renders a list of editable templates of type form
 */
const FormRender = ({
  formTemplate,
  onChange,
  onRemove,
  isEditable,
  mutation,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [modifiedSchema, setModifiedSchema] = useState(undefined);

  useEffect(() => {
    if (mutation.isSuccess) {
      // close modal when mutation has succeeded
      setVisible(false);
      mutation.reset();
    }
  }, [mutation.isSuccess]);

  const handleOK = useCallback(() => {
    if (modifiedSchema) {
      const clone = cloneDeep(formTemplate);
      clone.form = modifiedSchema;
      if (!isEqual(clone, formTemplate)) {
        onChange(formTemplate.layout_index, clone);
      }
    } else {
      setVisible(false);
    }
  }, [modifiedSchema, formTemplate, onChange]);

  const handleCancel = () => {
    mutation.reset();
    setModifiedSchema(undefined);
    setVisible(false);
  };

  const cardActions = [
    <Button
      key="delete"
      name="Delete"
      type="primary"
      icon={<DeleteOutlined />}
      onClick={() => onRemove(formTemplate.layout_index)}
      disabled={!isEditable}
    />,
  ];

  const cardTitle = `${formTemplate.name}`;
  const schemaToEdit = modifiedSchema ?? formTemplate?.form ?? {};

  return (
    <Card
      size="small"
      title={cardTitle}
      extra={cardActions}
      style={{ marginBottom: 10 }}
    >
      <Space orientation="vertical" size="middle">
        <Typography.Text>{formTemplate.description}</Typography.Text>

        <Button onClick={() => setVisible(true)}>
          {isEditable ? t("global:edit") : t("global:preview")}
        </Button>

        <SchemaBuilderFormModal
          open={visible}
          onCancel={handleCancel}
          onOk={handleOK}
          confirmLoading={mutation.isPending}
          okText={t("global:save")}
          okButtonProps={{ disabled: !modifiedSchema }}
        >
          <FormEditor
            schema={schemaToEdit}
            context="intervention_template"
            loading={false}
            onUpdateSchema={setModifiedSchema}
            isEditable={isEditable}
          />
        </SchemaBuilderFormModal>
      </Space>
    </Card>
  );
};

export default FormRender;
